// DS: i3.5
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const ArrowLeft: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M15.59 20.427a1 1 0 001.413-1.414l-7.07-7.071 7.07-7.071a1 1 0 10-1.414-1.414l-7.778 7.778a1 1 0 000 1.414l7.778 7.778z"
        clipRule="evenodd"
      ></path>
    </svg>
  </IconWrap>
);
ArrowLeft.displayName = 'ArrowLeft';

export default ArrowLeft;
